import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import { IHknrAccount, ISaveHknrAccountPayload } from '../types/hknr-account.type';

export const hknrAccountApi = createApi({
  reducerPath: 'hknrAccountApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/hknr/account`),
  endpoints: (builder) => ({
    connectAccount: builder.mutation<ApiResponse<IHknrAccount>, ISaveHknrAccountPayload>({
      query: (payload) => ({
        url: `/connect`,
        method: 'POST',
        body: payload,
      }),
    }),
    disconnectAccount: builder.mutation<ApiResponse<void>, void>({
      query: () => ({
        url: `/disconnect`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useConnectAccountMutation, useDisconnectAccountMutation } = hknrAccountApi;
